<template>
  <a class="kb-swipe-container" :href="images[currentIndex].targetUrl">
    <div class="kb-swipe-container__overlay-holder">
      <slot></slot>
    </div>
    <div class="kb-swipe-container__slide-holder" :style="slideHolderPosition">
      <div class="kb-swipe-container__slide" v-for="(image, index) in images" v-bind:key="index" v-hammer:swipe="swipe">
        <kb-base-image :src="isMobile ? image.srcMobile : image.src" :alt="image.alt"></kb-base-image>
      </div>
    </div>
  </a>
</template>

<script>
import { VueHammer } from 'vue2-hammer'
import Vue from 'vue';

Vue.use(VueHammer)
/**
 * Swipeable container for mobile touch gestures
 */
export default {
  name: 'kb-swiper-container',
  props: {
    images: {
      type: Array,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      currentIndex: 0
    }
  },
  computed: {
    slideHolderPosition: function() {
      return `transform: translate3d(-${this.currentIndex * 100}%, 0px, 0px)`;
    }
  },
  methods: {
    swipe: function($e) {
      if($e.direction === 2) {
        // Swiped to the left
        if((this.images.length - 1) > Math.abs(this.currentIndex)) {
          this.currentIndex++;
          this.$emit('change', this.currentIndex);
        }
      } else if ($e.direction === 4) {
        // Swiped to the right
        if(this.currentIndex > 0) {
          this.currentIndex--;
          this.$emit('change', this.currentIndex);
        }
      }
    },
    setIndex: function(index) {
      this.currentIndex = index;
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/_breakpoints';

.kb-swipe-container {
  display: block;
  position: relative;
  width: 100%;
  height: 334px;
  overflow: hidden;

  @media screen and (max-width: $breakPointMobile) {
    height: 410px;
  }

  &__overlay-holder {
    pointer-events: none;
    display: flex;
    position: absolute;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 360px;
    height: 100%;
    padding: 30px;

    @media screen and (max-width: $breakPointMobile) {
      padding: 0;
      align-items: flex-end;
      max-width: 100%;
    }

    & > .kb-image-overlay {
      max-width: 100%;

      @media screen and (max-width: $breakPointMobile) {
        height: auto;
        max-width: 100%;
        width: 100%;
      }
    }
  }

  &__slide-holder {
    position: absolute;
    z-index: 50;
    top: 0;
    left: 0;
    display: flex;
    height: 100%;
    width: 100%;
    transition: transform .3s ease-in-out;
  }

  &__slide {
    flex: 0 0 100%;
    overflow: hidden;
    width: 100%;
    max-width: 100%;

    img {
      min-width: 100%;
      min-height: 100%;
    }
  }
}
</style>